import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { AlertDirective } from '@shared/directives'

@Component({
  selector: 'app-winner-alert',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, AlertDirective],
  templateUrl: './winner-alert.component.html',
  styleUrl: './winner-alert.component.sass',
})
export class WinnerAlertComponent {
  @Input() show: boolean
  @Input() chips: number = 0
  @Input() bonus: number = 0
  @Input() bet: string
  @Output() onEnded = new EventEmitter<boolean>()

  readonly faXmark = faXmark

  showChange(show: boolean) {
    this.onEnded.emit(show)
  }
}
